import {
  Box,
  Button,
  Heading,
  HStack,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Text,
  VStack,
} from '@chakra-ui/react';
import { CheckCircleIcon } from '@chakra-ui/icons';

interface ReferralSuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  primaryColor: string;
  referralValue: number;
  submittedData: {
    name?: string;
    document?: string;
    telephone?: string;
    email?: string;
  } | null;
}

function formatDocument(doc: string): string {
  const clean = doc.replace(/\D/g, '');
  if (clean.length === 11) {
    return clean.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  }
  if (clean.length === 14) {
    return clean.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  }
  return doc;
}

export function ReferralSuccessModal({
  isOpen,
  onClose,
  primaryColor,
  referralValue,
  submittedData,
}: ReferralSuccessModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay backdropFilter="blur(4px)" />
      <ModalContent borderRadius="2xl" mx={4} overflow="hidden">
        <ModalBody padding={0}>
          <VStack spacing={0} align="stretch">
            {/* Header colorido */}
            <Box backgroundColor={primaryColor} padding="32px 24px 40px" textAlign="center">
              <CheckCircleIcon color="white" boxSize={14} mb={3} />
              <Heading fontSize="20px" fontWeight={700} color="white">
                Indicação enviada!
              </Heading>
              <Text fontSize="14px" color="whiteAlpha.900" mt={1}>
                Obrigado pela sua indicação
              </Text>
            </Box>

            {/* Dados e mensagem */}
            <VStack spacing={4} padding="24px" align="stretch">
              {/* Dados do indicado */}
              <Box backgroundColor="#F7F7F7" borderRadius="lg" padding="16px">
                <Text
                  fontSize="12px"
                  fontWeight={600}
                  color="#747474"
                  mb={2}
                  textTransform="uppercase"
                  letterSpacing="0.5px"
                >
                  Dados da indicação
                </Text>
                <VStack align="flex-start" spacing={1}>
                  {submittedData?.name && (
                    <HStack>
                      <Text fontSize="13px" color="#747474" minWidth="70px">Nome:</Text>
                      <Text fontSize="13px" fontWeight={600} color="#292927">{submittedData.name}</Text>
                    </HStack>
                  )}
                  {submittedData?.document && (
                    <HStack>
                      <Text fontSize="13px" color="#747474" minWidth="70px">CPF/CNPJ:</Text>
                      <Text fontSize="13px" fontWeight={600} color="#292927">{formatDocument(submittedData.document)}</Text>
                    </HStack>
                  )}
                  {submittedData?.telephone && (
                    <HStack>
                      <Text fontSize="13px" color="#747474" minWidth="70px">Telefone:</Text>
                      <Text fontSize="13px" fontWeight={600} color="#292927">{submittedData.telephone}</Text>
                    </HStack>
                  )}
                  {submittedData?.email && (
                    <HStack>
                      <Text fontSize="13px" color="#747474" minWidth="70px">E-mail:</Text>
                      <Text fontSize="13px" fontWeight={600} color="#292927" noOfLines={1}>{submittedData.email}</Text>
                    </HStack>
                  )}
                </VStack>
              </Box>

              {/* Mensagem */}
              <Text fontSize="14px" color="#747474" textAlign="center" lineHeight="1.6">
                Assim que o provedor receber este novo contrato, o valor de{' '}
                <Text as="span" fontWeight={700} color={primaryColor}>
                  R$ {referralValue.toFixed(2).replace('.', ',')}
                </Text>{' '}
                estará disponível no seu saldo. Muito obrigado por nos ajudar a crescer!
              </Text>

              <Button
                onClick={onClose}
                backgroundColor={primaryColor}
                color="white"
                borderRadius="full"
                height="48px"
                _hover={{ opacity: 0.9 }}
                _active={{ opacity: 0.8 }}
              >
                Fechar
              </Button>
            </VStack>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
